import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { SezioneEconomica } from '../../../../../models/sezioni/sezione-economica';
import {
  PersonalizzazioneDannoBiologicoFormComponent
} from '../../personalizzazione-danno-biologico-form/personalizzazione-danno-biologico-form/personalizzazione-danno-biologico-form.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
  selector: 'app-personalizzazione-danno-biologico-edit-modal',
  templateUrl: './personalizzazione-danno-biologico-edit-modal.component.html',
  styleUrls: ['./personalizzazione-danno-biologico-edit-modal.component.css']
})
export class PersonalizzazioneDannoBiologicoEditModalComponent implements OnInit {

  @ViewChild('dannoBiologicoFormComponent') dannoBiologicoFormComponent: PersonalizzazioneDannoBiologicoFormComponent;
  sezione: SezioneEconomica;
  @Input() idFascicolo: string;
  @Input() genericFascicolo: string
  @Input() tipoPraticaEndpoint: string;
  @Output() onReturnModal: EventEmitter<SezioneEconomica> = new EventEmitter<SezioneEconomica>();

  constructor() { }

  show(sezioneEconomica: SezioneEconomica){
    console.log(sezioneEconomica);
    this.sezione = sezioneEconomica;
    this.dannoBiologicoFormComponent.inizializza(this.sezione, this.genericFascicolo, this.idFascicolo, this.tipoPraticaEndpoint)
    openModal('dannoBiologicoModal');
  }

  onReturn(event: SezioneEconomica){
    closeModal('dannoBiologicoModal')
    this.onReturnModal.emit(event)
  }

  close() {
    closeModal('dannoBiologicoModal');
  }

  ngOnInit() {
  }

}
